import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { removeCustomLoader } from '../../@store/app.actions';

declare global {
  interface Window {
    DocSpring: any;
  }
}

@Injectable()
export class DocSpringService {
  private renderer: Renderer2;

  constructor(
    private readonly store: Store,
    private readonly rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.importDocSpring();
  }

  public createVisualForm(dataRequestId: string, tokenId: string, tokenSecret: string) {
    return new Observable((observer) => {
      document.defaultView?.DocSpring.createVisualForm({
        domainVerification: false,
        dataRequestId: dataRequestId,
        tokenId: tokenId,
        tokenSecret: tokenSecret,
        showSignatureModalOnFocus: true,
        closeModalOnSave: true,
        onInitialize: () => this.store.dispatch(removeCustomLoader({ loaderName: 'DocSpring' })),
        onSave: () => observer.next(),
        onError: (error: any) => observer.error(error),
      });
    });
  }

  private importDocSpring() {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.docspring.com/embed/data_request.v2.3.1.js';
    this.renderer.appendChild(document.body, script);
  }
}
